import { Button, Drawer } from "@/components";
import { DRAWER_COMMENT } from "@/const.ts";
import { CommentIcon } from "@/icons";
import { useResponsiveness } from "@/providers/context";

import { Comments, CommentsProps } from "@/app/modules/Comments/Comments.tsx";
import { useComments } from "@/app/modules/Comments/hooks/useComments.tsx";

export const CommentButton = (props: CommentsProps) => {
  const { openDrawer, setOpenDrawer } = useResponsiveness();

  const isOpen = openDrawer === DRAWER_COMMENT;

  const { sortedComments, label, labelWithCount } = useComments(props);

  return (
    <>
      <Button
        data-testid="comment-button"
        variant="secondary"
        onClick={() => setOpenDrawer(DRAWER_COMMENT)}
        size="s"
        className={!sortedComments ? "pr-7" : ""}
      >
        <CommentIcon className="mr-1 h-[20px] w-[20px]" /> {labelWithCount}
      </Button>
      <Drawer
        title={label}
        open={isOpen}
        onOpenChange={(open) => setOpenDrawer(open ? DRAWER_COMMENT : "")}
        dataTestId="comment-drawer"
      >
        <Comments {...props} />
      </Drawer>
    </>
  );
};
